import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = { class: "top-content" }
const _hoisted_3 = { class: "flex-row-centered" }

import {
    computed,
    onMounted,
    onUnmounted,
    ref,
    inject,
} from "vue";
// Services
import { apiLoggerKey } from "@/types/ServiceKeys";
import { MarketSelection, MonetaryValueWithCommas } from "@/services/helpers/Helper";
import useCarPurchasesVars from "@/services/helpers/CarPurchases/CarPurchasesVariables";
import {
    RowClicked,
    ParseCarPurchaseCollectiveCarSaleInvoices,
} from "@/services/helpers/CarPurchases/CarPurchasesFunctions";
// Data
import { ICarPurchasesCollectiveCarSaleInvoice } from "@/Interfaces/CarPurchases/ICarPurchasesCollectiveCarSaleInvoice";
import { marketSelection } from "@/services/helpers/Helper";
import { CarPurchasesCollectiveCarSaleInvoice } from "@/models/CarPurchases/CarPurchasesCollectiveCarSaleInvoice";
// Table
import Table from "@/components/TablePersistentChecking.vue";
// Misc
import log from "loglevel";
import { DisplayableKeys } from "@/services/SorterService";
import ErrorInfo from "@/components/ErrorInfo.vue";
import MarketSelector from "@/components/MarketSelector.vue";
import PeriodSelector from "@/components/PeriodSelector.vue";
import DatePeriod from "@/types/DatePeriod";
import { useRoute } from "vue-router";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";


export default /*#__PURE__*/_defineComponent({
  __name: 'CarPurchases',
  setup(__props) {

const GettingCarPurchasesErrorInfo = ErrorInfo;
const route = useRoute();
log.trace("CarPurchases");
const Logger = inject(apiLoggerKey);

const {
    isLoading,
    carPurchasesServices,
    carPurchasesDefaultSortCols,
    carPurchasesDefaultSortOrders,
} = useCarPurchasesVars();

const carPurchasesCols: DisplayableKeys<CarPurchasesCollectiveCarSaleInvoice>[] = [
	"CollectiveInvoiceId",
	"Market",
	"IssueDate",
	"Balance",
];
const carPurchasesLabels = [
	"Collective Invoice Id",
	"Market",
	"Issue Date",
	"Balance",
];
const invoices = ref<CarPurchasesCollectiveCarSaleInvoice[]>();
const displayedCarPurchases = computed(()=>invoices.value?.filter(x => period.value?.within(x.IssueDate)));
const carPurchasesPage = ref(1);
const carPurchasesRowCount = ref(40);
const period = ref<DatePeriod>();

const infoError = ref();

////////////////////////////////////////////////////////////////////////////
// LOGIC
////////////////////////////////////////////////////////////////////////////
onMounted(async () => {
    log.trace("onMounted() CarPurchases");
    document.title = 'CarPurchases - UV';
    marketSelection.value = 'GB'
    
    let routeMarket = route.params.market as string 
    if (Object.keys(MarketSelection).includes(routeMarket)){
        marketSelection.value = routeMarket as keyof typeof MarketSelection;
    } 
    await GetCollectiveCarSaleInvoices();
});
onUnmounted(() => {
    marketSelection.value = 'GB'
})
async function GetCollectiveCarSaleInvoices() {
    const name = __filename + "/" + GetCollectiveCarSaleInvoices.name;

    var Message = `Getting Car Purchases: (market: ${marketSelection.value})`;
    log.debug(`${name}()\n${Message}`);
    try {
        infoError.value = undefined;
        invoices.value = undefined;
        const response = await carPurchasesServices.GetCollectiveCarSaleInvoices<ICarPurchasesCollectiveCarSaleInvoice[]>(marketSelection.value);
        invoices.value = response.data
            .filter(carPurchase => (carPurchase.Balance ?? 0)>0)
            .map(ParseCarPurchaseCollectiveCarSaleInvoices);

        Logger?.LogInformation(Message, name);
    } catch (error) {

        infoError.value = error;
        useNotifierWithErrFormatter().error({
                name: "Car Purchases",
                errorType: "Car Purchases",
                error,
            });
    } finally {
        isLoading.value = false;
    }
}
/*
    Fetched new data when marketSelection changes.
    Triggered by marketSelection.change.
*/
async function updateMarketSelection() {
    await GetCollectiveCarSaleInvoices()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(MarketSelector, {
          onChange: updateMarketSelection,
          enableSE: ""
        }),
        _createVNode(PeriodSelector, {
          modelValue: period.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((period).value = $event)),
          showTitle: "",
          hasNullSelector: "",
          updateOnPropertyChange: _unref(marketSelection),
          filter: (p)=>invoices.value?.some(x=>p.within(x.IssueDate))
        }, null, 8, ["modelValue", "updateOnPropertyChange", "filter"])
      ])
    ]),
    _createVNode(Table, {
      Rows: displayedCarPurchases.value,
      Cols: carPurchasesCols,
      Labels: carPurchasesLabels,
      RowsPerPage: carPurchasesRowCount.value,
      "onUpdate:RowsPerPage": _cache[1] || (_cache[1] = ($event: any) => ((carPurchasesRowCount).value = $event)),
      Page: carPurchasesPage.value,
      "onUpdate:Page": _cache[2] || (_cache[2] = ($event: any) => ((carPurchasesPage).value = $event)),
      HasError: !!infoError.value,
      RowClickedCallBack: _unref(RowClicked),
      DefaultSortCols: _unref(carPurchasesDefaultSortCols),
      DefaultSortOrders: _unref(carPurchasesDefaultSortOrders)
    }, {
      Balance: _withCtx(({value}) => [
        _createTextVNode(_toDisplayString(_unref(MonetaryValueWithCommas)(value.Balance)), 1)
      ]),
      _: 1
    }, 8, ["Rows", "RowsPerPage", "Page", "HasError", "RowClickedCallBack", "DefaultSortCols", "DefaultSortOrders"])
  ]))
}
}

})